export var TypeActionPersistence;
(function (TypeActionPersistence) {
    TypeActionPersistence["WriteBeforeAction"] = "Persistence > WriteBeforeAction";
})(TypeActionPersistence || (TypeActionPersistence = {}));
export var actionPersistenceWriteBeforeAction = function (action, persistenceId, value, persistenceMode) { return ({
    action: action,
    persistenceId: persistenceId,
    persistenceMode: persistenceMode,
    type: TypeActionPersistence.WriteBeforeAction,
    value: value,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/persistence/actionPersistence.ts
// module id = 852
// module chunks = 3